<div class="form-floating" [ngClass]="{'without-label': label === ''}">
  <input 
    [type]="type" 
    [formControl]="control" 
    [id]="inputId" 
    class="form-control shadow-none" 
    [placeholder]="placeholder"
    autocomplete="off"
    (keypress)="onKeypressed($event)"
    (change)="onChanged($event)">
  <label *ngIf="label !== ''" [for]="inputId">{{ label }}</label>
  <div
    class="error-message"
    *ngIf="
      control.invalid &&
      control.touched &&
      control.errors">
    {{ getErrorMessage() | translate }}
  </div>
</div>
